import { ContextMenuItem } from "lib/@components/context-menu-bar/context-menu-item"
import { RegimeContextMenu } from "routes/regime/regime-context-menu"
import { notInSelector } from "routes/facilities/lib/when-parent-item"
import { deleteRegime } from "routes/schedule/my-schedules/my-custom-schedules/controller/delete-regime"
import { and } from "lib/logic"
import { hasDemand } from "lib/authorization/has-demand"
import { confirm } from "lib/@dialogs/confirm"

RegimeContextMenu.plug(<DeleteRegime if={and(notInSelector, () => hasDemand("manageRegime"))} />)

export function DeleteRegime({ regime }) {
    return (
        <ContextMenuItem
            onClick={remove}
            icon="material-symbols:delete"
            label="Delete Regime"
            data-cy="delete-regime-menu-item"
        />
    )

    async function remove() {
        const confirmed = await confirm(
            `${regime.label} will be moved to the recycle bin.
You can restore it at any time from there.`,
            `Delete ${regime.label}?`,
            undefined,
            "Delete"
        )
        if (!confirmed) return
        await deleteRegime(regime._id)
    }
}
